/* ==========================================================================
   IRON CREST LEATHER — variant-picker.js   (theme only)

   The static prototype had one hard-coded variant, so its swatches and size
   buttons only had to look selected. On a store they have to choose a real
   variant, and that is all this file does.

   It deliberately does not own any UI state. product-page.js already sets
   aria-pressed on the swatches and .is-selected on the sizes; this listens
   afterwards, reads whatever is currently selected, finds the matching variant
   and writes it to the four places that need it:

     · the form's hidden `id`  — what actually gets added to the cart
     · the Add to bag button's data-id / data-price — what product-card.js posts
     · the price line
     · the stock line, and the button's disabled state

   Splitting it this way means neither file has to know how the other paints.
   ========================================================================== */
(function () {
  function boot() {
    'use strict';

    var form = document.getElementById('pdp-form');
    var blob = document.querySelector('[data-variants]');
    if (!form || !blob) return;

    var variants;
    try { variants = JSON.parse(blob.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;
    if (form.icBooted) return;   // already live; the editor replaced a different section
    form.icBooted = true;

    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var priceNow = document.querySelector('[data-price-now]');
    var stock = document.querySelector('[data-stock]');
    var stockText = document.querySelector('[data-stock-text]');
    var colourName = document.querySelector('[data-colour-name]');

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    function money(cents) {
      var units = Math.round(cents) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: currency,
          minimumFractionDigits: units % 1 === 0 ? 0 : 2
        }).format(units);
      } catch (e) {
        return '$' + units.toLocaleString('en-US');
      }
    }

    /* ---- what is selected right now, by option position ---- */
    function chosen() {
      var out = {};
      Array.prototype.forEach.call(form.querySelectorAll('[data-option-group]'), function (group) {
        var pos = parseInt(group.getAttribute('data-option-group'), 10);
        var on = group.querySelector('[aria-pressed="true"], .is-selected');
        if (!on) return;
        // a swatch carries its value in aria-label, a size button in data-value
        out[pos] = on.getAttribute('data-value') || on.getAttribute('aria-label') || on.textContent.trim();
      });
      return out;
    }

    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var pos in sel) {
          if (!Object.prototype.hasOwnProperty.call(sel, pos)) continue;
          if (String(v.options[pos - 1]) !== String(sel[pos])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function apply() {
      var sel = chosen();
      var v = match(sel);
      if (!v) return;

      if (idInput) idInput.value = v.id;
      if (colourName && sel[1]) colourName.textContent = sel[1];

      if (priceNow) priceNow.textContent = money(v.price);

      if (addBtn) {
        addBtn.setAttribute('data-id', v.id);
        addBtn.setAttribute('data-price', Math.round(v.price / 100));
        addBtn.setAttribute('data-variant', v.title || '');
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (addBtn.getAttribute('data-label') || addBtn.textContent.replace(/^Sold out$/, 'Add to bag'))
          : 'Sold out';
      }

      if (stock && stockText) {
        // Shopify only exposes inventory_quantity when the merchant tracks it
        var left = v.inventory_management ? v.inventory_quantity : null;
        if (v.available && typeof left === 'number' && left > 0 && left <= 5) {
          stockText.textContent = 'Only ' + left + ' left in this size';
          stock.hidden = false;
        } else {
          stock.hidden = true;
        }
      }

      // keep the address bar honest so a shared link opens the same variant
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    // after product-page.js has repainted the pressed state, not before
    form.addEventListener('click', function (e) {
      if (!e.target.closest('.swatch, .pdp__size')) return;
      setTimeout(apply, 0);
    });

    if (addBtn) addBtn.setAttribute('data-label', addBtn.textContent.trim());
    apply();
  }

  boot();

  /* The editor replaces a section's markup wholesale on every change, so the
     script has to run again over the new nodes. Storefront visitors never get
     here -- they booted once above. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { boot(); });
  }
})();
